import { useTranslation } from "react-i18next";
import { useOnboardingTourOptional } from "../../../context/OnboardingTourContext";

export default function InteractiveTourSpotlight() {
  const { t } = useTranslation();
  const tour = useOnboardingTourOptional();

  if (!tour?.isActive || !tour.activeStep) {
    return null;
  }

  const { activeStep, stepIndex, totalSteps, targetRect, nextStep, prevStep, skipModule, isTransitioning } =
    tour;

  const isLast = stepIndex >= totalSteps - 1;
  const tooltipStyle = targetRect
    ? {
        top: Math.min(targetRect.top + targetRect.height + 14, window.innerHeight - 220),
        left: Math.min(Math.max(targetRect.left, 16), window.innerWidth - 360),
      }
    : {
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      };

  return (
    <div className="interactive-tour-root" role="presentation">
      <div className="interactive-tour-backdrop" onClick={skipModule} aria-hidden="true" />

      {targetRect ? (
        <div
          className="interactive-tour-highlight"
          style={{
            top: targetRect.top,
            left: targetRect.left,
            width: targetRect.width,
            height: targetRect.height,
          }}
        />
      ) : null}

      <div
        className={`interactive-tour-tooltip${targetRect ? "" : " interactive-tour-tooltip--centered"}`}
        style={tooltipStyle}
        role="dialog"
        aria-live="polite"
      >
        <p className="interactive-tour-tooltip__eyebrow">
          {t("tourStepCounter", { current: stepIndex + 1, total: totalSteps })}
        </p>
        <h3>{t(activeStep.titleKey)}</h3>
        <p>{t(activeStep.bodyKey)}</p>

        <div className="interactive-tour-tooltip__actions">
          <button type="button" className="interactive-tour-btn interactive-tour-btn--ghost" onClick={skipModule}>
            {t("tourSkipModule")}
          </button>
          <div className="interactive-tour-tooltip__nav">
            <button
              type="button"
              className="interactive-tour-btn interactive-tour-btn--ghost"
              onClick={() => void prevStep()}
              disabled={stepIndex === 0 || isTransitioning}
            >
              {t("tourPrevious")}
            </button>
            <button
              type="button"
              className="interactive-tour-btn interactive-tour-btn--primary"
              onClick={() => void nextStep()}
              disabled={isTransitioning}
            >
              {isLast ? t("tourFinish") : t("tourNext")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
